import React, {useEffect, useRef, useState} from 'react';
import { useT, guestsLabel, useLocale, intlLocale } from '../../../../../../helpers/i18n';
import { useInViewport } from 'react-in-viewport';
import Skeleton from 'react-loading-skeleton';
import { faUserFriends as farUserFriends } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Dialog from '@mui/material/Dialog';
import Popover from '@mui/material/Popover';

import Checkers from '../../../../../../helpers/class/Checkers';
import Guests from '../../../../index/bookingSearchBar/partials/Guests';
import {useDispatch, useSelector} from "react-redux";
import LgConsts from "../../../../../../helpers/LgConsts";
import DateRangeWrapper from "../../../partials/bookings/DateRangeWrapper";
import {generateBookUrlHandler, generateIquiryUrlHandler, priceHandler} from "../../../../../../helpers/HandlerHelper";
import StickyBox from "react-sticky-box";
import RightModal from "../../../../properties/partials/RightModal";
import ContentWrapper from "../../../../properties/partials/ContentWrapper";
import {setCheckout, updateBookingFormTriggered} from "../../../../../../redux/actions";
import {enableBookingBtn, fetchBuilderSettingByKey} from "../../../../../../helpers/MethodHelper";

export default function BookNow ( props ) {
  const dateLocale = useLocale();
  const t = useT();
  const config = {disconnectOnLeave: false};
  const options = {};
  const myRef = useRef();
  const {
    inViewport
  } = useInViewport(
      myRef,
      options,
      config,
      props
  );

  const dispatch = useDispatch()

  const checkin = useSelector(state => state['propertiesParams']['checkin'])

  const checkout = useSelector(state => state['propertiesParams']['checkout'])

  const priceLoading = useSelector(state => state['appSettings']['priceLoading'])

  const propertyInitialAvailability = useSelector(state => state['propertyAvailability']['initialAvailability'])

  const showIquires = useSelector(
      state => fetchBuilderSettingByKey(state['builderSettingsData'], 'builder_bookings_inquires_allow')
  );

  const inquiriesOnly  = useSelector(state => state['appSettings']['inquiriesOnly'])

  const adults = useSelector(state => state['propertiesParams']['adults'])

  const kids = useSelector(state => state['propertiesParams']['kids'])

  const infants = useSelector(state => state['propertiesParams']['infants'])

  const personsForBooking = (adults + kids + infants)

  const bookingFormTriggered = useSelector(state => state['appSettings']['bookingFormTriggered'])

  useEffect(() => {
    if (!propertyInitialAvailability) {
      dispatch(setCheckout(null))
    }
  }, [propertyInitialAvailability])

  const builder = props.builder;

  let builder_booking_box_border = false;
  let builder_booking_box_shadow = false;
  let builder_booking_box_radius = 0;
  let builder_booking_box_class = 'booking-orders-design-box col-12 col-sm-8 col-md-6 col-lg-12 ms-auto me-auto ms-lg-0 me-lg-0';
  if (builder != null) {
    builder_booking_box_border = Checkers.isValidObjString(builder, 'builder_booking_box_border') ? builder.builder_booking_box_border : false;
    builder_booking_box_shadow = Checkers.isValidObjString(builder, 'builder_booking_box_shadow') ? builder.builder_booking_box_shadow : false;
    builder_booking_box_radius = Checkers.isValidObjString(builder, 'builder_booking_box_radius') ? builder.builder_booking_box_radius : 0;
  }

  let white_class = 'bg-master-lightest';
  if (!builder_booking_box_border && !builder_booking_box_shadow && builder_booking_box_radius === 0) {
    white_class = 'bg-white';
  }

  if (builder_booking_box_border) {
    builder_booking_box_class += '\ b-grey b-a';
  }
  if (builder_booking_box_shadow) {
    builder_booking_box_class += '\ box-shadow';
  }
  if (builder_booking_box_radius > 0) {
    builder_booking_box_class += `\ b-radius-${builder_booking_box_radius}`;
  }
  builder_booking_box_class += '\ text-center no-overflow';
  ;

  const priceValue = useSelector(state => state['appSettings']['price'])

  const finalPriceValue = useSelector(state => state['appSettings']['finalPrice'])

  const climateResilienceTax = useSelector(state => state['appSettings']['climateResilienceTax'])

  const showClimateResilienceTax = useSelector(state => Checkers.valueToBoolean(state['builderSettingsData']['settings']['builder']['page_show_climate_resilience_tax']))

  const discountValue = useSelector(state => state['appSettings']['discount'])

  const hasDiscount = useSelector(state => state['appSettings']['hasDiscount'])

  const accommondationLength = useSelector(state => state['appSettings']['accommondationLength'])

  const securityDeposit = useSelector(state => state['appSettings']['securityDeposit'])

  const dateRangeValid = useSelector(state => state['propertiesParams']['dateRangeValid'])

  const page_id = useSelector(state => state['propertiesParams']['page_id'])

  const property_id = useSelector(state => state['propertiesParams']['property_id'])

  const priceNeedUpdate = useSelector(state => state['propertiesParams']['priceNeedUpdate'])

  const priceInitialized = useSelector(state => state['appSettings']['priceLoading'])

  useEffect( () => {
    priceHandler(
        dispatch,
        false,
        page_id,
        property_id,
        priceInitialized,
        checkin,
        checkout,
        priceNeedUpdate,
        adults,
        kids
    )
  }, [priceNeedUpdate, dateRangeValid])

  const enableButtons = enableBookingBtn(propertyInitialAvailability, priceLoading, personsForBooking, dateRangeValid)


  // useEffect( () => {
  //   console.log("personsForBooking", bookingFormTriggered, personsForBooking, Checkers.isValidPositiveNumber(personsForBooking), (propertyInitialAvailability || priceLoading) && !Checkers.isValidPositiveNumber(personsForBooking) )
  // }, [personsForBooking])

  const hasError = () => {
    if (bookingFormTriggered && !enableButtons) {
      return true
    }

    return false
  }

  const bookingType = useSelector(state => state['appSettings']['bookingType'])

  const hidePrices = useSelector(state => state['appSettings']['hidePrices'])

  const bookUrl = generateBookUrlHandler()

  const inquiryUrl = generateIquiryUrlHandler()

  const [show, setShow] = useState(false);
  const [modalState, setModalState] = useState("close");

  const formatNumber = (value: number) =>
      value.toLocaleString(intlLocale(dateLocale), {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      })


  const handleShow = (state) => {
    setShow(true);
    setModalState(state);
  }

  const handleHide = () => {
    setShow(false);
    setModalState("close");
  }

  let viewPortResult = null;
  if (!inViewport) {
    viewPortResult =
        <div ref={myRef}>
          <Skeleton height={540} className="col-12 b-rad-lg d-none d-sm-block"/>
        </div>
    ;
  } else {
    viewPortResult =
        <>
          <div className={builder_booking_box_class}>
            <div className="bg-white p-t-15 p-b-15">
              <h3 className="font-montserrat">{t('booking.inquireNow')}</h3>
              <p className="font-montserrat no-margin text-overflow p-l-10 p-r-10 small-text p-b-0">
                {t('booking.needHelp')}
              </p>
              <p className="font-montserrat no-margin fs-14 p-t-0">
                <a href={'tel:' + props.phone} className="text-master bold">
                  {props.phone}
                </a>
              </p>
            </div>
            <div className="p-t-20 p-b-20 p-l-20 p-r-20 bg-white">
              <form id="frm_02">
                <div className="row mb-2">
                  <DateRangeWrapper forList={false} theme={props.calendar.customTheme} isStatic={0}/>
                  <div className="col-12 text-left">
                    <div className={"form-group form-group-default input-group-attached m-b-0 " + (hasError() ? 'has-error' : '') }>
                      <label id="guests_label" htmlFor="guests" className="form-label bold">
                        <FontAwesomeIcon className="hidden-md" icon={farUserFriends}/> {t('search.guests')}
                      </label>
                      <p className={'w-100 fs-14 fw-normal no-margin text-master text-truncate opacity-70 hidden-xs hidden-sm'}
                         onClick={props.popover.handleOpen}
                         aria-describedby={props.popover.id}
                         style={{cursor: 'pointer'}}
                      >
                        {guestsLabel(t, props.popover.guestsText)}
                      </p>
                      <p
                          className={'w-100 fw-normal text-master text-truncate fs-14 no-margin opacity-70 visible-xs visible-sm visible-md'}
                          onClick={props.dialog.handleOpen}
                          style={{cursor: 'pointer'}}
                      >
                        {guestsLabel(t, props.popover.guestsText)}
                      </p>
                      <Popover
                          className="hidden-xs hidden-sm"
                          id={props.popover.id}
                          open={props.popover.open}
                          anchorEl={props.popover.anchorEl}
                          onClose={props.popover.handleClose}
                          anchorOrigin={{
                            vertical: 'bottom',
                            horizontal: 'left',
                          }}
                          transformOrigin={{
                            vertical: 'top',
                            horizontal: 'left',
                          }}
                      >
                        <Guests popover={props.popover} dialog={props.dialog} mobile={false}/>
                      </Popover>
                      <Dialog onClose={props.dialog.handleClose} open={props.dialog.open}>
                        <Guests popover={props.popover} dialog={props.dialog} mobile={true}/>
                      </Dialog>
                    </div>

                    <p className={(hasError() ? 'visible' : 'invisible') + " fs-11 text-danger d-inline-block w-100 m-b-0"}>* {t('booking.fieldRequired')}</p>
                  </div>
                </div>
              </form>
              {
                hidePrices != 1 ?
                    <div className={"price-wrapper"}>
                      {/*<p className="font-montserrat all-caps small hint-text m-b-0">Reduced price&nbsp;*/}
                      {/*  <span style={{textDecoration: "line-through"}}>2444,50€</span>*/}
                      {/*</p>*/}
                      {priceLoading ?
                          <Skeleton height={16} className="col-12 b-rad-lg"/>
                          :
                          hasDiscount && dateRangeValid ?
                              // <span className={'m-l-10 text-danger fs-14'}>{discountValue} € discount</span>
                              <p className="font-montserrat all-caps small hint-text m-b-0">{t('booking.reducedPrice')} <span
                                  style={{textDecoration: "line-through"}}>{priceValue} €</span></p>
                              :
                              <p className="font-montserrat all-caps small hint-text m-b-0">&nbsp;<span>&nbsp;</span>
                              </p>
                      }
                      <h3 className="font-montserrat m-t-0 m-b-0">
                        {
                          priceLoading ?
                              <Skeleton height={32} className="col-12 b-rad-lg"/>
                              :
                              <>
                                {
                                  propertyInitialAvailability && finalPriceValue != null && dateRangeValid ?
                                      <>
                                        {finalPriceValue} €
                                        {/*{hasDiscount ?*/}
                                        {/*    <span>*/}
                                        {/*      <span*/}
                                        {/*          className={'m-l-10 line-through text-danger fs-22'}>{priceValue} €</span>*/}
                                        {/*    </span>*/}
                                        {/*    :*/}
                                        {/*    <></>*/}
                                        {/*}*/}
                                      </>
                                      :
                                      <>
                                        <span style={{lineHeight: "40px"}}
                                              className={'fs-15'}>{t('booking.addDatesForPrice')}</span>
                                      </>
                                }
                              </>
                        }
                      </h3>
                      <p className="small m-b-0 m-t-0">
                        {
                          propertyInitialAvailability && finalPriceValue != null && dateRangeValid ?
                              <span onClick={() => handleShow('modal_detail_charges')}
                                    style={{cursor: "pointer"}}
                                    className="text-black hint-text">
                                  <span className="hidden-sm">{t('booking.view')}</span> {t('booking.details')}
                                </span>
                              :
                              <p className="text-black hint-text"></p>
                        }
                        <RightModal
                            key={100}
                            modalName={'modal_detail_charges'}
                            className="slide_right"
                            Title={t('booking.chargesExplained')}
                            modalSize="lg"
                            loaderStatus={false}
                            closeModal={() => {
                              handleHide()
                            }}
                            show={modalState === 'modal_detail_charges'}
                            BodyRender={<ContentWrapper ContentRender={
                              <>
                                <table className="table m-t-0 m-b-10">
                                  <thead>
                                  <tr>
                                    <th className="padding-10" colSpan={2}
                                        style={{paddingLeft: "10px !important;"}}>{t('booking.description')}
                                    </th>
                                  </tr>
                                  </thead>
                                  <tbody>
                                  {
                                    propertyInitialAvailability ?
                                        <>
                                          {
                                            hasDiscount ?
                                                <>
                                                  {/*<tr>*/}
                                                  {/*  <td className="padding-10 v-align-middle semi-bold">Reduced price*/}
                                                  {/*    ({accommondationLength} nights)*/}
                                                  {/*  </td>*/}
                                                  {/*  <td width="1px"*/}
                                                  {/*      className="p-l-10 p-t-10 p-b-10 v-align-middle semi-bold text-right bold">{priceValue}&nbsp;€*/}
                                                  {/*  </td>*/}
                                                  {/*</tr>*/}
                                                  <tr>
                                                    <td className="padding-10 v-align-middle semi-bold">{t('booking.discount')}</td>
                                                    <td width="1px"
                                                        className="p-l-10 p-t-10 p-b-10 v-align-middle semi-bold text-right bold">- {discountValue}&nbsp;€
                                                    </td>
                                                  </tr>
                                                </>
                                                :
                                                <></>
                                          }
                                          <tr>
                                            <td style={{borderBottom: securityDeposit ? null : 'none' }} className="padding-10 v-align-middle semi-bold">{t.plural('booking.accommodation', accommondationLength)}
                                            </td>
                                            <td width="1px"
                                                style={{borderBottom: securityDeposit ? null : 'none' }}
                                                className="p-l-10 p-t-10 p-b-10 v-align-middle semi-bold text-right bold">{finalPriceValue}&nbsp;€
                                            </td>
                                          </tr>
                                          {
                                            showClimateResilienceTax && Checkers.isValidPositiveNumber(climateResilienceTax) ?
                                                <>
                                                  <tr>
                                                    <td style={{borderBottom: securityDeposit ? null : 'none'}}
                                                        className="padding-10 v-align-middle semi-bold">
                                                      {t('booking.climateTax')}
                                                    </td>
                                                    <td width="1px"
                                                        style={{borderBottom: securityDeposit ? null : 'none'}}
                                                        className="p-l-10 p-t-10 p-b-10 v-align-middle semi-bold text-right bold">{formatNumber(climateResilienceTax)}&nbsp;€
                                                    </td>
                                                  </tr>
                                                </>
                                                :
                                                <>
                                                </>
                                          }
                                        </>
                                        :
                                        <></>
                                  }
                                  {
                                    securityDeposit ?
                                        <tr>
                                          <td style={{borderBottom: 'none'}}
                                              className="padding-10 v-align-middle semi-bold">{t('booking.securityDeposit')}
                                          </td>
                                          <td width="1px" style={{borderBottom: 'none'}}
                                              className="p-l-10 p-t-10 p-b-10 v-align-middle semi-bold text-right bold">{securityDeposit}&nbsp;€
                                          </td>
                                        </tr>
                                        :
                                        <></>
                                  }
                                  <tr>
                                    <td className="p-r-5 v-align-middle semi-bold text-right"
                                        style={{borderBottom: "none"}}>
                                      <h4 className="no-margin font-montserrat text-overflow text-editorial-dark">{t('booking.total')}</h4>
                                    </td>
                                    <td width="1px" className="p-l-5 v-align-middle semi-bold text-right"
                                        style={{borderBottom: "none"}}>
                                      <h4 className="no-margin font-montserrat bold text-editorial-dark">{finalPriceValue}&nbsp;€</h4>
                                    </td>
                                  </tr>
                                  </tbody>
                                </table>
                              </>
                            }/>}
                        />
                      </p>
                    </div>
                    :
                    ""
              }
            </div>
            <div className={white_class + '\ p-t-20 p-b-20 p-l-10 p-r-10'}>
              <div className="row p-r-10 p-l-10">
                {
                  (inquiriesOnly == '1' || showIquires == '1' || bookingType == LgConsts.BOOKING_TYPE_1_INQUIRIES) ?
                      <div className={"col"} onClick={ () => {
                        dispatch( updateBookingFormTriggered(true) )
                      }}>
                        <a className={"btn btn-lg btn-default btn-black full-width btn-bordered " + ( enableButtons ? '' : 'disabled')}
                           target="_blank" rel="noreferrer" href={inquiryUrl}>{t('booking.inquire')}</a>
                      </div>
                      :
                      ""
                }
                {
                  inquiriesOnly != '1' && Checkers.isValidString(bookUrl) && (bookingType == LgConsts.BOOKING_TYPE_2_WEBHOTELIER || (propertyInitialAvailability && bookingType == LgConsts.BOOKING_TYPE_1_INQUIRIES)) ?
                      <div onClick={ () => {
                        dispatch( updateBookingFormTriggered(true) )
                      }} className={"col"}>
                        <a className={"btn btn-lg btn-primary btn-design-color full-width " + ( enableButtons ? '' : 'disabled')}
                           target="_blank" rel="noreferrer" href={bookUrl}>{t('booking.bookNow')}</a>
                      </div>
                      :
                      <></>
                }
              </div>
              <p className="small hint-text m-t-15 m-b-5">{t('booking.notChargedYet')}</p>
            </div>
          </div>

          {
              Checkers.isValidString(props.legalLicense) &&
              <div className="p-t-20 p-l-20">
                <p className="font-arial fs-11 small-text no-margin">
                  <span className="hint-text text-master">{t('booking.licenseIntro')}</span>
                  {t('booking.tourismOrg')}
                  <span className="hint-text">{t('booking.licenseNo')}</span>
                  {props.legalLicense}
                </p>
              </div>
          }
        </>
    ;
  }

  return (
      <StickyBox offsetTop={20} offsetBottom={20}>
        <div className="pb-3 d-none d-sm-block">
          {viewPortResult}
        </div>
      </StickyBox>
  )
}